<template>
  <div id="app">
    <a-config-provider :locale="zhCN">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
// import DevicePixelRatio from '@/utils/devicePixelRatio'

export default {
  data() {
    return {
      zhCN,
    }
  },
  created() {
    // new DevicePixelRatio().init()
  }
}

</script>

<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: PingFang SC,PingFangSC-Medium,Tahoma,Arial,Droid Sans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  scrollbar-width: none;
}

#nav {
  // padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
::-webkit-scrollbar {
  width: 1px;
  background: rgba($color: #000000, $alpha: .9);
  height: 1px;
}
::-webkit-scrollbar-thumb {
  background: rgba($color: #000000, $alpha: .9);
}
.banner-amt {
    animation: bannerAmt 1.5s ease-in-out .3s both
}

@keyframes bannerAmt {
    0% {
        background-size: 150% 150%
    }

    to {
        background-size: 100% 100%
    }
}
</style>
